import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createApp } from '~/app'
import { parseEnv } from '~/config/env'
import './index.css'

const root = document.getElementById('root')
if (root === null) {
  throw new Error('#root is missing in index.html')
}

const App = createApp(parseEnv(import.meta.env))

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
